export default class CallError {
    static DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again in a few minutes.';
    static ErrorMap = new Map([
        [2000, 'App not found.'],
        [2001, 'Publisher not found.'],
        [2002, CallError.DEFAULT_ERROR_MESSAGE],
        [2003, CallError.DEFAULT_ERROR_MESSAGE],
        [2004, CallError.DEFAULT_ERROR_MESSAGE],
    ]);

    constructor(type, originalContent, code = undefined, additionalInfo = {}) {
        this.type = type;
        this.code = type === 'params' ? 400 : code;
        this.originalContent = originalContent;
        if (type === 'params') {
            if (additionalInfo.missingParams) {
                this.missingParams = additionalInfo.missingParams;
            }
            if (additionalInfo.badParams) {
                this.badParams = additionalInfo.badParams;
            }
            if (additionalInfo.message) {
                this.message = additionalInfo.message;
            } else if (this.missingParams?.length || this.badParams?.length) {
                this.message = '';
                if (this.missingParams?.length) {
                    this.message = `Missing required parameters: ${this.missingParams.join(', ')}`;
                }
                if (this.badParams?.length) {
                    if (this.message.length) {
                        this.message += '. ';
                    }

                    this.message += `Bad parameters: ["${this.badParams.map((o) => o.error).join('", "')}"]`;
                }
            } else {
                this.message = 'No message was provided for this error. Check the originalContent attribute.';
            }
        } else {
            if (additionalInfo.message) {
                this.message = additionalInfo.message;
            } else {
                this.message = 'No message was provided for this error. Check the originalContent attribute.';
            }
        }
        this.message = this.message.trim();

        /** case env with this name already exists */
        if (type === 'http' && this.code === 409) {
            this.userMessage = this.originalContent?.error ?? CallError.DEFAULT_ERROR_MESSAGE;
        } else {
            this.userMessage = CallError.ErrorMap.get(Number(originalContent?.error_code)) ?? CallError.DEFAULT_ERROR_MESSAGE;
        }
    }
}
